import React from 'react'
import PropTypes from 'prop-types'

import { P } from './styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'size' implicitly has an 'any' typ... Remove this comment to see the full error message
const Text = ({ size, weight, color, children, className }) => (
  // @ts-expect-error TS(2769) FIXME: No overload matches this call.
  <P size={size} weight={weight} color={color} className={className}>
    {children}
  </P>
)

Text.propTypes = {
  size: PropTypes.number,
  weight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

Text.defaultProps = {
  size: 14,
  weight: 'normal',
  color: 'black',
}

export default Text
